import { tagName } from "@ember-decorators/component"
import Component from "@ember/component"
import styles from "./add-to-routine-button.module.css"

@tagName("")
export default class AddToRoutineButtonTs extends Component {
  readonly styles = styles
}
